module.exports = __webpack_public_path__ + "static/img/list-item-8.42f77ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/list-item-8.png
// module id = I0xW
// module chunks = 1